import type { FaireProductEntity } from "../../entity_types/product";

export const p_rv54f3aupg: FaireProductEntity = {
  token: "p_rv54f3aupg",
  type: "product",
  name: 'Thick Base Modern Wine Glass-5"H(10oz) - Clearance',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/3c8ba6112dd21cf53d101e182d69c8e7e7b34e682a5df4611e01da5c9a82d94f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9ef56301a5896e5c602dfd28928e227535e83a83bbb04883889cf520ef2dce8.jpeg",
    "https://cdn.faire.com/fastly/4cbfc9145106387a074f3ffaffafea633ddcb0b29cd08b8aa543158dd211f64a.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Whether it's a special occasion or an ordinary weeknight, this Thick Base Modern Wine Glass is perfect for everything from homemade blends to elevated vintages. Crafted out of glass, its durable, wide body and sturdy base create a classic yet contemporary look that's sure to complement any style of dinnerware or decor. Thick Base All Purpose Glass also available.",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:12.230Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
